/**
 * The stages, as this gardener has them, from StagesContext.
 *
 * A hook rather than useContext at each call, so a component outside its
 * provider fails at once with a sentence saying so, instead of reading
 * undefined and failing somewhere further on.
 *
 * @module useStagesContext
 */

import { useContext } from 'react';
import { StagesContext, StagesContextType } from '../context/StagesContextDefinition';

/**
 * The StagesProvider's value.
 *
 * @returns The stages and the lookups on them.
 * @throws Error when called outside a StagesProvider.
 */
export function useStagesContext(): StagesContextType {
  const context = useContext(StagesContext);
  if (context === undefined) {
    throw new Error('useStagesContext must be used within a StagesProvider');
  }
  return context;
}